import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import HlsToolBar from 'components/HlsToolbar';
import axios from 'axios';
import LayoutPanel from 'components/LayoutPanel';
import SideMenu from 'components/SideMenu';
import HlsSideMenu from 'components/HlsSideMenu';
import { toast } from 'react-hot-toast';
import { checkDivsInMainPanel } from 'utils';
const ManualComponent = () => {
  const [buttonState, setButtonState] = useState('');
  const [broadcastId, setBroadcastId] = useState('');
  const [states, setStates] = useState(false);
  const [hlsLink, setHlsLink] = useState('');
  const [condition, setCondition] = useState(false);
  let { pid, roleName, userName, userId } = useParams();
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [sessionId, setSessionId] = useState();
  const [stats, setStats] = useState(null);
  const [streamData, setStreamData] = useState();
  const [count, setCount] = useState();
  const [streams, setStreams] = useState();
  const [isCurrentHost, setIsCurrentHost] = useState(false);
  const [broadcastType, setBroadcastType] = useState('auto');
  const state = useSelector((state) => state);
  let session;
  let broadcast;
  const subscriberRef = useRef(null);
  const publisherRef = useRef(null);
  const mainPanelRef = useRef(null); // Ref for main-panel
  const subscriberArrayRef = useRef([]); // Ref for subscriberArray
  const toastId = `toast-${Date.now()}`;
  const [publisher, setPublisher] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [videoKbps, setVideoKbps] = useState();
  const [audioKbps, setAudioKbps] = useState();
  const [isScreenshareClicked, setIsScreenshareClicked] = useState(false);
  const [currentHost, setCurrentHost] = useState(1);
  const [selectedLayout, setSelectedLayout] = useState();
  const mainPanelDivCheck = checkDivsInMainPanel();
  const [open, setOpen] = useState(false);
  const [showNotificationChat, setShowNotificationChat] = useState(false);
  const [networkStatus, setNetworkStatus] = useState(true);
  const [isDisconnected, setIsDisconnected] = useState(false);
  const [isLocalUserConnected, setIsLocalUserConnected] = useState(true);
  const [liveEventUrl, setLiveEventUrl] = useState('');
  const [isBroadcasting, setIsBroadcasting] = useState(false);
  useEffect(() => {
    if (window.session) {
      // Detect if the user loses connection due to a network issue
      window.session.on('sessionDisconnected', (event) => {
        if (event.reason === 'networkDisconnected' && !isDisconnected) {
          toast.error(
            'You have lost connection to the livestream. Please check your network.'
          );
          setIsLocalUserConnected(false);
          setIsDisconnected(true);
        }
      });

      // Detect if the user reconnects after losing internet
      window.session.on('connectionCreated', (event) => {
        if (
          event.connection.connectionId ===
          window.session.connection?.connectionId
        ) {
          setIsLocalUserConnected(true);
          if (isDisconnected) {
            setIsDisconnected(false);
          }
        }
      });
    }
  }, [isDisconnected]);

  useEffect(() => {
    const checkInternetConnection = () => {
      if (!navigator.onLine && networkStatus) {
        if (!isDisconnected) {
          toast.error('You have lost internet connection.');
          setIsDisconnected(true);
          setIsLocalUserConnected(false);
        }
        setNetworkStatus(false);
      } else if (navigator.onLine && !networkStatus) {
        setNetworkStatus(true);

        setTimeout(() => {
          if (!window.session?.connection) {
            console.log(
              'Session not connected, keeping reconnect button visible.'
            );
          } else {
            console.log('Session is connected, hiding reconnect button.');
            setIsDisconnected(false);
            setIsLocalUserConnected(true);
          }
        }, 5000);
      }
    };

    window.addEventListener('offline', checkInternetConnection);
    window.addEventListener('online', checkInternetConnection);

    return () => {
      window.removeEventListener('offline', checkInternetConnection);
      window.removeEventListener('online', checkInternetConnection);
    };
  }, [networkStatus, isDisconnected]);

  const handleReconnect = async () => {
    if (!navigator.onLine) {
      toast.error(
        'No internet connection. Please try again after reconnecting.'
      );
      return;
    }

    if (window.session?.connection) {
      console.log('Session is already connected. No need to reconnect.');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/session/${pid}/${userName}/${userId}/${roleName}`
      );
      const res = await response.json();

      if (res.apiKey && res.sessionId && res.token) {
        console.log('Reconnecting session...');
        initializeSession(res.apiKey, res.sessionId, res.token);
        toast.success('Reconnecting...');

        window.session.on('sessionConnected', () => {
          console.log('Session reconnected successfully!');

          setTimeout(() => {
            // **Properly remove old publisher before creating a new one**
            if (window.publisher) {
              console.log('Unpublishing and destroying existing publisher...');
              window.session.unpublish(window.publisher);
              window.publisher.destroy(); // Destroy old publisher
              window.publisher = null;
            }

            console.log('Creating new publisher...');
            window.publisher = window.OT.initPublisher(
              'publishers',
              {
                insertMode: 'append',
                width: '100%',
                height: '100%',
                resolution: '1280x720',
                publishAudio: true,
                publishVideo: true,
                audioFallback: {
                  publisher: true,
                },
              },
              (error) => {
                if (error) {
                  console.error('Failed to initialize new publisher:', error);
                  toast.error('Failed to initialize new camera stream.');
                  return;
                }

                console.log('New publisher initialized, attaching events...');

                // Attach event listeners to the new publisher
                window.publisher.on('streamCreated', () => {
                  console.log('Stream created event triggered.');
                  setPublisher(window.publisher);
                });

                window.publisher.on('streamDestroyed', () => {
                  console.log('Stream destroyed event triggered.');
                });

                // Publish camera again
                console.log('Publishing camera to session...');
                window.session.publish(window.publisher, (error) => {
                  if (error) {
                    console.error('Failed to republish:', error);
                    toast.error('Failed to restart camera stream.');
                  } else {
                    toast.success('Camera stream restarted successfully.');

                    // Ensure toolbar functionalities work
                    setPublisher(window.publisher);

                    // **Ensure old publishers are removed from subscriberArrayRef**
                    subscriberArrayRef.current =
                      subscriberArrayRef.current.filter(
                        (sub) => sub.streamId !== window.publisher.streamId
                      );

                    // **Now add the new publisher**
                    subscriberArrayRef.current.push(window.publisher);
                    setStreams(subscriberArrayRef.current);
                  }
                });
              }
            );
          }, 3000);
        });

        setTimeout(() => {
          setIsLocalUserConnected(true);
          setIsDisconnected(false);
        }, 5000);
      } else {
        toast.error('Failed to reconnect. Please refresh the page.');
      }
    } catch (error) {
      console.error('Reconnect failed:', error);
      toast.error('Reconnect failed. Please try again.');
    }
  };

  const checkAWSRTMP = async (retryCount = 5) => {
    try {
      if (sessionStorage.getItem('broadcastId')) {
        const requestOptions = {
          method: 'POST',
          redirect: 'follow',
        };

        fetch(
          `${
            process.env.REACT_APP_API_URL
          }/v2/livemeeting/broadcast/status/${sessionStorage.getItem(
            'broadcastId'
          )}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result?.broadcastUrls?.rtmp[0]?.status === 'live') {
              if (retryCount > 0) {
                console.warn(`RTMP missing. Retrying... (${5 - retryCount}/5)`);
                setTimeout(() => checkAWSRTMP(retryCount - 1), 5000);
              } else {
                toast.error(
                  'RTMP stream to AWS is missing! Restarting broadcast.'
                );
                handleStartBroadcast(liveEventUrl);
              }
            }
          })
          .catch((error) => console.error(error));
      }
    } catch (error) {
      console.error('Failed to check AWS RTMP status:', error);
    }
  };

  useEffect(() => {
    const handleDynamicDivClick = async (event) => {
      if (event.target.closest('.OT_mute')) return;

      if (!sessionStorage.getItem('broadcastId')) {
        toast.error(`Can’t publish media until live`);
        return;
      }

      const mainPanel = document.getElementById('main-panel');
      const screenShareDiv = document.getElementById('hls-screen-shares');

      const otDivs = Array.from(mainPanel.querySelectorAll('div')).filter(
        (div) =>
          div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
      );
      const layoutSelected = sessionStorage.getItem('layoutSelected');
      const isPipOrCustomLayout =
        layoutSelected === 'pip' || layoutSelected === 'custom';

      sessionStorage.setItem('isHost', 'true'); // Store as string
      const clickedDynamicDiv = event.target.closest("[id^='OT_']");
      if (
        !clickedDynamicDiv ||
        clickedDynamicDiv.getAttribute('data-processing') === 'true'
      )
        return;

      const dynamicId = clickedDynamicDiv.id;
      clickedDynamicDiv.classList.toggle('highlight-border');
      setStates(true);

      const isInMainPanel = mainPanel.contains(clickedDynamicDiv);
      const originalContainer =
        clickedDynamicDiv.getAttribute('data-original-container') ||
        clickedDynamicDiv.parentElement.id;
      clickedDynamicDiv.setAttribute(
        'data-original-container',
        originalContainer
      );

      if (!isInMainPanel && isPipOrCustomLayout && otDivs.length >= 1) {
        toast.error(
          'Can’t add more than one speaker to the selected layout. Remove additional speakers from live stage, then re-select layout.'
        );
        return;
      }

      clickedDynamicDiv.setAttribute('data-processing', 'true'); // Disable further clicks
      let toastId = toast.loading(`Processing...`);

      for (let sub of subscriberArrayRef.current) {
        if (sub.id === dynamicId) {
          const action = isInMainPanel ? 'removeStream' : 'addStream';

          try {
            const response = await fetch(
              `${
                process.env.REACT_APP_API_URL
              }/v2/livemeeting/broadcast/${action}/${sessionStorage.getItem(
                'broadcastId'
              )}/${sub.streamId}`,
              { method: 'POST' }
            );
            const result = await response.json();

            if (response.ok) {
              toast.success(
                `Stream ${
                  action === 'addStream' ? 'added' : 'removed'
                } successfully.`,
                { id: toastId }
              );

              // **Move the stream after successful API call**
              if (!isInMainPanel) {
                mainPanel.appendChild(clickedDynamicDiv);
              } else {
                const targetContainer =
                  document.getElementById(originalContainer) ||
                  document.querySelector('.left-panel');
                targetContainer.appendChild(clickedDynamicDiv);
              }

              // **Ensure UI remains stable in backstage**
              resetLeftPanelStyles();

              // **Send signal to other hosts only after successful API**
              handleStreamPushed(
                sub.streamId,
                action,
                originalContainer === 'publishers'
                  ? 'subscribers'
                  : 'publishers'
              );
              changeLayout(
                layoutSelected || sessionStorage.getItem('layoutSelected')
              );
            } else {
              throw new Error('API call failed');
            }
          } catch (error) {
            toast.error(
              `Failed to ${
                action === 'addStream' ? 'add' : 'remove'
              } stream. Try again.`,
              { id: toastId }
            );
            console.error('API error:', error);
          } finally {
            clickedDynamicDiv.removeAttribute('data-processing'); // Re-enable clicking after API response
          }

          break; // Exit loop after processing correct stream
        }
      }
    };

    // Attach the event listener to the parent divs
    const subscriberDiv = subscriberRef.current;
    if (subscriberDiv) {
      subscriberDiv.addEventListener('click', handleDynamicDivClick);
      // console.log("Attached click listener to subscriberDiv");
    }

    const publisherDiv = publisherRef.current;
    if (publisherDiv) {
      publisherDiv.addEventListener('click', handleDynamicDivClick);
      // console.log("Attached click listener to publisherDiv");
    }

    const mainPanel = document.getElementById('main-panel');
    if (mainPanel) {
      mainPanel.addEventListener('click', handleDynamicDivClick);
      // console.log("Attached click listener to mainPanel");
    }

    // Clean up event listeners on component unmount
    return () => {
      if (subscriberDiv) {
        subscriberDiv.removeEventListener('click', handleDynamicDivClick);
        // console.log("Removed click listener from subscriberDiv");
      }
      if (publisherDiv) {
        publisherDiv.removeEventListener('click', handleDynamicDivClick);
        // console.log("Removed click listener from publisherDiv");
      }
      if (mainPanel) {
        mainPanel.removeEventListener('click', handleDynamicDivClick);
        // console.log("Removed click listener from mainPanel");
      }
    };
  }, []); // Empty dependency array ensures this runs once

  useEffect(() => {
    if (publisher !== null) {
      setIsLoading(false);
    }
  }, [publisher]);

  const handleStreamPushed = async (
    streamId,
    action,
    originalContainer,
    retryCount = 3
  ) => {
    if (session) {
      const signalData = JSON.stringify({
        streamId,
        action,
        originalContainer,
      });

      try {
        await session.signal({ type: 'stream-pushed', data: signalData });
        console.log(`Stream ${streamId} ${action} signal sent successfully`);
        changeLayout(sessionStorage.getItem('layoutSelected'));
      } catch (error) {
        console.error('Failed to send stream signal:', error);
        if (retryCount > 0) {
          console.log(`Retrying to send signal... (${3 - retryCount + 1}/3)`);
          setTimeout(
            () =>
              handleStreamPushed(
                streamId,
                action,
                originalContainer,
                retryCount - 1
              ),
            1000
          );
        } else {
          toast.error('Failed to sync stream across hosts. Please refresh.');
        }
      }
    }
  };

  const postSessionId = async (sessionId) => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/v2/video/media/livemeeting/session/${pid}`,
        {
          sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );
      // console.log("Success:", response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (!session) {
      fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/session/${pid}/${userName}/${userId}/${roleName}`,
        {
          method: 'GET',
        }
      )
        .then((res) => res.json())
        .then((res) => {
          postSessionId(res.sessionId);
          setSessionId(res.sessionId);
          sessionStorage.setItem('sessionId', res.sessionId);
          const apiKey = res.apiKey;
          const sessionId = res.sessionId;
          const token = res.token;
          initializeSession(apiKey, sessionId, token);
        })
        .catch(handleCallback);
    }
  }, [pid, roleName, userName, userId]); // Added dependencies

  const initializeSession = (apiKey, sessionId, token) => {
    // Create a session object with the sessionId
    session = window.OT.initSession(apiKey, sessionId);
    // console.log("Is Host:", sessionStorage.getItem("isHost"));

    session.on('signal', (event) => {
      if (event.type === 'signal:stream-pushed') {
        let streamId = sessionStorage.getItem('streams');
        let streamIds = JSON.parse(streamId) || [];

        // Parse or initialize the 'streamsInLive' data separately
        let streamsInLive =
          JSON.parse(sessionStorage.getItem('streamsInLive')) || [];

        let signalStreamId = JSON.parse(event.data);

        // Check if the streamId already exists in the streamsInLive array
        const existingStreamIndex = streamsInLive.findIndex(
          (item) => item.streamId === signalStreamId.streamId
        );

        if (signalStreamId.action === 'addStream') {
          if (existingStreamIndex === -1) {
            // Add a new entry with inLive: true
            streamsInLive.push({
              streamId: signalStreamId.streamId,
              inLive: true,
            });
          } else {
            // Update the existing entry's inLive status to true
            streamsInLive[existingStreamIndex].inLive = true;
          }
          changeLayout(sessionStorage.getItem('layoutSelected'));
        } else if (signalStreamId.action === 'removeStream') {
          if (existingStreamIndex !== -1) {
            // Update the inLive status to false
            streamsInLive[existingStreamIndex].inLive = false;
          }
          changeLayout(sessionStorage.getItem('layoutSelected'));
        }

        // Save the updated 'streamsInLive' array to sessionStorage
        sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));

        const divId = streamIds.filter(
          (item) => item.streamId === signalStreamId.streamId
        );

        if (divId.length > 0) {
          const clickedDynamicDiv = document.getElementById(divId[0].id);
          // console.log("Signal received for div:", clickedDynamicDiv);

          if (
            sessionStorage.getItem('isHost') === 'false' ||
            sessionStorage.getItem('isHost') === null
          ) {
            if (clickedDynamicDiv) {
              // Toggle the highlight class based on the broadcasted data
              // clickedDynamicDiv.classList.toggle('highlight-border');
            }
            if (clickedDynamicDiv) {
              if (signalStreamId.action === 'addStream') {
                requestAnimationFrame(() => {
                  document
                    .querySelector('.main-panel')
                    .appendChild(clickedDynamicDiv);
                });
                setTimeout(() => {
                  changeLayout(sessionStorage.getItem('layoutSelected'));
                }, 2000);
              } else if (signalStreamId.action === 'removeStream') {
                let mainPanelDivCheck = checkDivsInMainPanel();
                if (mainPanelDivCheck) {
                  if (
                    mainPanelDivCheck.isHlsScreenSharePresent &&
                    mainPanelDivCheck.otDivCount === 0
                  ) {
                    const screenShareDiv =
                      document.getElementById('hls-screen-shares');
                    if (screenShareDiv) {
                      screenShareDiv.style.height = '100%';
                      screenShareDiv.style.width = '100%';
                    }
                  }
                }
                if (signalStreamId.originalContainer === 'publishers') {
                  const publisherDiv = document.getElementById('publishers');
                  const existingDivs =
                    publisherDiv.querySelectorAll('div.OT_root');
                  if (existingDivs.length > 0) {
                    const subscribersDiv =
                      document.getElementById('subscribers');
                    // Check if there are any existing cameras inside the subscribers div
                    const existingDivs =
                      subscribersDiv.querySelectorAll('div.OT_root');

                    if (existingDivs.length > 0) {
                      // Append the new camera stream div below the existing ones
                      subscribersDiv.appendChild(clickedDynamicDiv);
                    } else {
                      // If no camera streams exist, simply append the clicked div as the first child
                      subscribersDiv.appendChild(clickedDynamicDiv);
                    }

                    // Optionally, apply specific styling for the new div if needed
                    clickedDynamicDiv.style.marginTop = '20px';
                  } else {
                    const targetContainer = document.getElementById(
                      signalStreamId.originalContainer
                    );

                    if (targetContainer) {
                      targetContainer.appendChild(clickedDynamicDiv);
                    } else {
                      document
                        .querySelector('.left-panel')
                        .appendChild(clickedDynamicDiv);
                    }
                  }
                } else {
                  const subscribersDiv = document.getElementById('subscribers');
                  // Check if there are any existing cameras inside the subscribers div
                  const existingDivs =
                    subscribersDiv.querySelectorAll('div.OT_root');

                  if (existingDivs.length > 0) {
                    // Append the new camera stream div below the existing ones
                    subscribersDiv.appendChild(clickedDynamicDiv);
                  } else {
                    // If no camera streams exist, simply append the clicked div as the first child
                    subscribersDiv.appendChild(clickedDynamicDiv);
                  }

                  // Optionally, apply specific styling for the new div if needed
                  clickedDynamicDiv.style.marginTop = '20px';
                }
              }
              setTimeout(() => {
                changeLayout(sessionStorage.getItem('layoutSelected'));
              }, 4000);
              resetLeftPanelStyles();
            }
          }
        }
      }
    });

    window.session = session;

    // Check if the publisher already exists to prevent duplicates
    if (!window.publisher) {
      // Create a publisher
      const publisher = window.OT.initPublisher(
        'publishers',
        {
          videoFilter: {
            type:
              localStorage.getItem('filterPayload') === 'high' ||
              localStorage.getItem('filterPayload') === 'low'
                ? 'backgroundBlur'
                : 'backgroundReplacement',
            backgroundImgUrl: localStorage.getItem('filterPayload'),
          },
          publishAudio: state.waitingRoomReducer.localAudio,
          publishVideo: state.waitingRoomReducer.localVideo,
          fitMode: 'contain',
          insertMode: 'append',
          width: '100%',
          height: '100%',
          resolution: '1280x720',
          audioFallback: {
            publisher: true,
          },
        },
        handleCallback
      );
      setPublisher(publisher);
      window.publisher = publisher;
      subscriberArrayRef.current.push(window.publisher); // Push to ref array
      // console.log("Publisher added to subscriberArrayRef:", window.publisher);
    }

    // Connect to the session
    session.connect(token, (error) => {
      // If the connection is successful, initialize the publisher and publish to the session
      if (error) {
        handleCallback(error);
      } else {
        if (window.publisher) {
          session.publish(window.publisher, handleCallback);
        }
        setIsLocalUserConnected(true);
        setIsDisconnected(false);
      }
    });

    // Subscribe to a newly created stream
    session.on('streamCreated', (event) => {
      setCurrentHost((x) => x + 1);
      if (event.stream.videoType === 'screen') {
        getStreamData(sessionId);
        setIsScreenSharing(true);
        const screenShareDiv = document.getElementById('hls-screen-shares');
        if (screenShareDiv) {
          screenShareDiv.style.display = 'block';
        }
      }
      const streamContainer =
        event.stream.videoType === 'screen'
          ? 'hls-screen-shares'
          : 'subscribers';
      window.subscriber = session.subscribe(
        event.stream,
        streamContainer,
        {
          insertMode: 'append',
          width: '100%',
          height: '100%',
        },
        handleCallback
      );
      subscriberArrayRef.current.push(window.subscriber); // Push to ref array
      // console.log(
      //   "Subscribed to stream, current subscribers:",
      //   subscriberArrayRef.current
      // );
      setCount(subscriberArrayRef.current.length);
      setStreams(subscriberArrayRef.current);
      let data =
        subscriberArrayRef.current &&
        subscriberArrayRef.current.map((item) => {
          return { streamId: item.streamId, id: item.id };
        });
      sessionStorage.setItem('streams', JSON.stringify(data));
      setCondition(true);
    });

    session.on('streamDestroyed', (event) => {
      // if (event.stream.videoType === 'screen') {
      //   handleScreenShareClick();
      // }
      if (event.stream.videoType === 'screen') {
        setIsScreenSharing(true);
        const screenShareDiv = document.getElementById('hls-screen-shares');
        if (screenShareDiv) {
          screenShareDiv.style.display = 'none';
        }
      }
      if (event?.stream?.videoType === 'camera') {
        setCount((x) => x - 1);
        setCurrentHost((x) => x - 1);
        setCondition(false);
        subscriberArrayRef.current.pop();
        // console.log(
        //   "Stream destroyed (camera), updated subscribers:",
        //   subscriberArrayRef.current
        // );
      } else {
        setIsScreenSharing(false);
        setCount((x) => x - 1);
        setCurrentHost((x) => x - 1);
        subscriberArrayRef.current.pop();
        // console.log(
        //   "Stream destroyed (non-camera), updated subscribers:",
        //   subscriberArrayRef.current
        // );
      }
    });
  };

  function handleCallback(error) {
    if (error) {
      console.log('error: ' + error.message);
    } else {
      console.log('callback success');
    }
  }

  useEffect(() => {
    // Function to push streams to the live section on page load
    const pushStreamsToLiveSection = () => {
      // Retrieve the array of streams in live from session storage
      const liveStreams =
        JSON.parse(sessionStorage.getItem('streamsInLive')) || [];

      if (liveStreams.length > 0) {
        const storedSubscriberArray =
          JSON.parse(sessionStorage.getItem('streams')) || [];

        // Loop through each live stream and match it with subscriberArrayRef
        liveStreams.forEach((liveStream) => {
          // Find the corresponding stream in storedSubscriberArray
          const matchingStream = storedSubscriberArray.find(
            (stream) =>
              stream.streamId === liveStream.streamId && liveStream.inLive
          );

          if (matchingStream) {
            // Get the corresponding DOM element for the stream
            const streamDiv = document.getElementById(matchingStream.id);

            if (
              streamDiv &&
              !document.querySelector('.main-panel').contains(streamDiv)
            ) {
              // Append the streamDiv to the live section (only if it's not already there)
              document.querySelector('.main-panel').appendChild(streamDiv);
              // console.log(`Stream ${matchingStream.id} moved to live section.`);
            }
          }
        });
      }

      if (
        sessionStorage.getItem('isScreenshareInLive') == 'true' &&
        !sessionStorage.getItem('isHost')
      ) {
        const mainPanel = document.getElementById('main-panel');
        const screenshareDiv = document.getElementById('hls-screen-shares');
        mainPanel.appendChild(screenshareDiv);
        if (mainPanelDivCheck.otDivCount == 0) {
          screenshareDiv.style.height = '90%';
        }
      }
      changeLayout(sessionStorage.getItem('layoutSelected'));
    };

    // Call the function when the component is mounted
    setTimeout(pushStreamsToLiveSection, 9000);
  }, []);

  const handleStartBroadcast = async (liveEventUrl) => {
    let streamMode = sessionStorage.getItem('broadcastType');
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/start`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: session.sessionId,
            liveEventUrl,
            streamMode: streamMode ? streamMode : 'manual',
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Broadcast start failed:', {
          status: response.status,
          statusText: response.statusText,
          responseText: errorText,
          url: response.url,
          requestBody: JSON.stringify({
            session_id: session.sessionId,
            liveEventUrl,
            streamMode: streamMode ? streamMode : 'manual',
          }),
        });
        throw new Error(
          `Failed to start broadcast: ${response.status} ${response.statusText}`
        );
      }

      const res = await response.json();
      setButtonState('start');
      sessionStorage.setItem('broadcastId', res.broadcast.id);
      setBroadcastId(res.broadcast.id);
      broadcast = res.broadcast.id;
      setIsBroadcasting(true);
      console.log('Broadcast started successfully:', res);
    } catch (error) {
      console.error('Error in handleStartBroadcast:', {
        message: error.message,
        stack: error.stack,
        liveEventUrl,
        streamMode,
        sessionId: session?.sessionId,
      });
      toast.error(`Failed to start broadcast: ${error.message}`);
      handleCallback(error);
    }
  };

  const handleStopBroadcast = () => {
    sessionStorage.removeItem('isScreenshareInLive');
    sessionStorage.removeItem('streamsInLive');
    sessionStorage.removeItem('streams');
    sessionStorage.removeItem('layoutSelected');
    sessionStorage.removeItem('broadcastType');
    sessionStorage.removeItem('streamMode');
    sessionStorage.removeItem('screenshareLayout');
    sessionStorage.removeItem('isScreenshareClicked');
    sessionStorage.removeItem('layouts');
    fetch(
      `${
        process.env.REACT_APP_API_URL
      }/v2/livemeeting/broadcast/stop/${sessionStorage.getItem('broadcastId')}`,
      {
        method: 'POST',
      }
    )
      .then((res) => {
        sessionStorage.removeItem('broadcastId');
        setIsBroadcasting(false);
        return res.json();
      })
      .then((res) => {
        setButtonState('stop');
        sessionStorage.removeItem('streamMode');
        sessionStorage.removeItem('broadcastId');
        // console.log("Broadcast stopped:", res);
      })
      .catch(handleCallback);
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    // Cleanup the event listener
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const handleMessage = (e) => {
    try {
      const jsonParse = JSON.parse(e.data);
      if (jsonParse.action === 'startBroadcastClick') {
        setLiveEventUrl(jsonParse.liveEventUrl);
        handleStartBroadcast(jsonParse.liveEventUrl);
      }
      if (jsonParse.action === 'endBroadcastClick') {
        handleStopBroadcast();
      }
    } catch (error) {
      console.error('Error parsing message data:', error);
    }
  };

  const startScreenSharing = () => {
    setIsCurrentHost(true);
    const OT = window.OT;
    setIsScreenSharing(true);
    const screenShareDiv = document.getElementById('hls-screen-shares');
    if (screenShareDiv) {
      screenShareDiv.style.display = 'block';
    }
    let publishOptions = {
      videoSource: 'screen',
      width: '100%',
      height: '25%',
    };
    window.hlsScreenShare = OT.initPublisher(
      'hls-screen-shares',
      publishOptions,
      function (error) {
        if (error) {
          // Look at error.message to see what went wrong.
          console.log(error);
        } else {
          window.session.publish(window.hlsScreenShare, function (error) {
            if (error) {
              // Look error.message to see what went wrong.
              console.log(error);
            }

            getStreamData(sessionId);
          });
        }
      }
    );
  };

  const stopScreenSharing = () => {
    setIsCurrentHost(false);
    setIsScreenSharing(false);
    window.session.unpublish(window.hlsScreenShare);
    window.hlsScreenShare.destroy();

    if (window.hlsScreenShare) {
      // Reappend the div in the same position below the 'publishers' div
      const leftPanel = document.querySelector('.left-panel');
      const publishersDiv = document.getElementById('publishers');
      if (leftPanel && publishersDiv) {
        // Create a new div for the screen share
        const newScreenShareDiv = document.createElement('div');
        newScreenShareDiv.id = 'hls-screen-shares';
        newScreenShareDiv.style.display = 'none'; // Hide the div initially
        newScreenShareDiv.style.height = '25%';
        newScreenShareDiv.style.width = '100%';
        newScreenShareDiv.style.marginTop = '10px';
        newScreenShareDiv.className =
          sessionStorage.getItem('broadcastType') === 'manual'
            ? 'screen-share hls-screen-shares OT_root OT_publisher OT_fit-mode-contain'
            : 'screen-share hls-screen-shares OT_root OT_publisher OT_fit-mode-contain';

        newScreenShareDiv.addEventListener('click', handleScreenshareClicked);

        const mainPanel = document.getElementById('main-panel');
        const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
          (div) => div.id && div.id.startsWith('OT')
        );
        if (otDiv) {
          otDiv.style.height = '100%';
          otDiv.style.width = '100%';
        }

        // Insert the new screen share div after the 'publishers' div
        publishersDiv.insertAdjacentElement('afterend', newScreenShareDiv);
        console.log('Screen share div reappended below the publishers div.');
      }
    }
  };

  const getStreamData = (sessionId) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/streamData/${sessionId}`,
      {
        method: 'POST',
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setStreamData(res);
        setStreamClass(res.response);
        console.log('Stream Data:', res);
      })
      .catch(handleCallback);
  };
  const setStreamClass = (streamData) => {
    let streamDataArray = [];
    const streamDataSet =
      streamData &&
      streamData.map((item) => {
        if (item.videoType === 'screen') {
          let data = { id: item.id, layoutClassList: ['full'] };
          streamDataArray.push(data);
        }
      });
    fetch(
      `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/setStreamClassList`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId,
          classListArray: streamDataArray,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log('Class are set:', res);
      })
      .catch(handleCallback);
  };

  function resetLeftPanelStyles() {
    const leftPanel = document.querySelector('.left-panel');
    if (leftPanel) {
      // Set style for publishers div
      const publishersDiv = document.querySelector(
        '.left-panel #publishers div[id^="OT_"]'
      );

      if (publishersDiv) {
        // Set height and width to 100%
        publishersDiv.style.height = '100%';
        publishersDiv.style.width = '100%';
        publishersDiv.style.position = '';
      }

      // Set style for each OT div inside subscribers
      const subscriberDivs = document.querySelectorAll(
        '.left-panel #subscribers div[id^="OT_"]'
      );

      subscriberDivs.forEach((div) => {
        div.style.height = '100%';
        div.style.width = '100%';
        div.style.position = '';
      });
    }
  }

  const handleScreenShareClick = async () => {
    changeLayout(sessionStorage.getItem('layoutSelected'));
    setIsScreenshareClicked(false);

    const mainPanel = document.getElementById('main-panel');
    const screenshareDiv = document.getElementById('hls-screen-shares');
    let id;

    streamData.response.forEach((item) => {
      if (item.videoType === 'screen') {
        id = item.id;
      }
    });

    // Prevent multiple clicks while processing
    if (
      !screenshareDiv ||
      screenshareDiv.getAttribute('data-processing') === 'true'
    )
      return;
    screenshareDiv.setAttribute('data-processing', 'true');
    screenshareDiv.classList.toggle('highlight-border');

    let toastId = toast.loading('Processing...');

    const isInMainPanel = mainPanel.contains(screenshareDiv);
    const action = isInMainPanel ? 'removeStream' : 'addStream';

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/v2/livemeeting/broadcast/${action}/${sessionStorage.getItem(
          'broadcastId'
        )}/${id}`,
        { method: 'POST' }
      );
      const result = await response.json();

      if (response.ok) {
        toast.success(
          `Screenshare ${
            action === 'addStream' ? 'added' : 'removed'
          } successfully.`,
          { id: toastId }
        );

        if (!isInMainPanel) {
          // Move to main-panel
          mainPanel.appendChild(screenshareDiv);
          if (mainPanelDivCheck.otDivCount == 0) {
            screenshareDiv.style.height = '90%';
          }
        } else {
          // Move back to left-panel
          resetLayouts();
          screenshareDiv.style.height = '25%';
          screenshareDiv.style.width = '100%';
          const backstageButtonDiv =
            document.getElementById('backstage-button');
          backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
        }

        // Update layout styles
        resetLeftPanelStyles();

        // Signal to other hosts after successful API
        if (window.session) {
          window.session.signal(
            {
              type: 'move-screenshare',
              data: isInMainPanel ? 'left-panel' : 'main-panel',
            },
            (error) => {
              if (error) {
                console.error(
                  'Error sending screenshare signal:',
                  error.message
                );
              }
            }
          );
        }

        // Update screenshare state in sessionStorage
        sessionStorage.setItem('isScreenshareInLive', !isInMainPanel);

        changeLayout(sessionStorage.getItem('layoutSelected'));
      } else {
        throw new Error('API call failed');
      }
    } catch (error) {
      toast.error(
        `Failed to ${
          action === 'addStream' ? 'add' : 'remove'
        } screenshare. Try again.`,
        { id: toastId }
      );
      console.error('Screenshare API error:', error);
    } finally {
      screenshareDiv.removeAttribute('data-processing');
    }
  };

  useEffect(() => {
    if (streamData && isScreenSharing && isScreenshareClicked) {
      handleScreenShareClick();
    }
  }, [streamData, isScreenSharing, isScreenshareClicked]);

  let previousVideoBytesRate = 0;
  let previousAudioBytesRate = 0;
  let weakNetworkCount = 0;
  let hasWarned = false;
  useEffect(() => {
    if (publisher && isBroadcasting) {
      let startTime;
      const handleStreamCreated = () => {
        console.log('Stream created. Starting stats monitoring.');
        startTime = Date.now();

        const intervalId = setInterval(() => {
          if (publisher?.stream && publisher?.session?.connection) {
            publisher.getStats((error, statsArray) => {
              if (error) {
                console.error('Failed to get stats:', error);
                return;
              }

              if (statsArray && statsArray.length > 0) {
                const stats = statsArray[0].stats;

                const videoBytesKbs =
                  ((stats.video.bytesSent - previousVideoBytesRate) * 8) / 1000;
                const audioBytesKbs =
                  ((stats.audio.bytesSent - previousAudioBytesRate) * 8) / 1000;

                previousVideoBytesRate = stats.video.bytesSent;
                previousAudioBytesRate = stats.audio.bytesSent;

                setVideoKbps(videoBytesKbs);
                setAudioKbps(audioBytesKbs);

                if (Date.now() - startTime < 5000) return; // Grace period

                if (videoBytesKbs < 100 || audioBytesKbs < 30) {
                  weakNetworkCount++;
                } else {
                  weakNetworkCount = 0;
                  hasWarned = false;
                }

                if (weakNetworkCount >= 5 && !hasWarned) {
                  toast.error(
                    'Your connection is unstable. Video/audio quality may be affected.'
                  );
                  hasWarned = true;
                }
              }
            });
          }
        }, 1000);

        publisher.on('streamDestroyed', () => {
          clearInterval(intervalId);
        });
      };

      publisher.once('streamCreated', handleStreamCreated);
    }
  }, [publisher, isBroadcasting]);

  const handleScreenshareClicked = () => {
    if (sessionStorage.getItem('broadcastId')) {
      setIsScreenshareClicked(true);
    } else {
      toast(`Can’t publish media until live`);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (sessionStorage.getItem('broadcastId')) {
        const requestOptions = {
          method: 'POST',
          redirect: 'follow',
        };

        fetch(
          `${
            process.env.REACT_APP_API_URL
          }/v2/livemeeting/broadcast/status/${sessionStorage.getItem(
            'broadcastId'
          )}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result?.broadcastUrls?.rtmp[0]?.status === 'live') {
              window.parent.postMessage(
                { type: 'BROADCAST_STATUS', data: result },
                '*'
              );
              clearInterval(interval);
            }
          })
          .catch((error) => console.error(error));
      }
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  // console.log("inside manual");

  function changeLayout(selectedLayout) {
    // Get the main panel
    let mainPanelDivCheck = checkDivsInMainPanel();
    if (
      (mainPanelDivCheck?.isHlsScreenSharePresent &&
        mainPanelDivCheck.otDivCount > 0) ||
      selectedLayout == 'bestFit'
    ) {
      const mainPanel = document.getElementById('main-panel');
      const screenShareDiv = document.getElementById('hls-screen-shares');
      if (!mainPanel) return;

      mainPanel.style.flexWrap = '';
      // Find all divs inside the main panel whose id starts with 'OT'
      const otDivs = Array.from(mainPanel.querySelectorAll('div')).filter(
        (div) =>
          div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
      );

      if (
        (otDivs?.length > 1 && selectedLayout === 'custom') ||
        (otDivs?.length > 1 && selectedLayout === 'pip')
      ) {
        if (!sessionStorage.getItem('isToastVisible')) {
          sessionStorage.setItem('isToastVisible', true);
          toast('Can not Select more than one host for this layout', {
            id: toastId, // Prevents duplicate toasts with the same ID
            duration: 2000, // Duration in milliseconds (optional)
          });
          // Use a timeout to clear the session storage after the toast duration
          setTimeout(() => {
            console.log('Clearing session storage');
            sessionStorage.removeItem('isToastVisible');
          }, 2000); // Match this duration with the toast duration
        }
      } else {
        // Check if an ot-wrapper exists for verticalPresentation layout
        let otWrapper = document.getElementById('ot-wrapper');

        // Reset styles for other layouts before applying new ones
        if (selectedLayout !== 'verticalPresentation' && otWrapper) {
          // Reset the styles applied during the verticalPresentation layout
          otWrapper.style.display = '';
          otWrapper.style.flexDirection = '';
          otWrapper.style.width = '';
          otWrapper.style.height = '';
          otWrapper.style.marginRight = '';

          // Reset styles for each otDiv to remove vertical layout adjustments
          otDivs.forEach((otDiv) => {
            otDiv.style.width = '';
            otDiv.style.height = '';
            otDiv.style.marginBottom = '';
          });

          // Remove the otWrapper but keep otDivs inside the mainPanel
          while (otWrapper.firstChild) {
            mainPanel.appendChild(otWrapper.firstChild);
          }
          otWrapper.remove();
        }
        // Find the first div inside the main panel whose id starts with 'OT'
        const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
          (div) =>
            div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
        );

        if (!otDiv) {
          console.log('No div with id starting with OT found.');
          return;
        }

        if (
          selectedLayout === 'custom' ||
          selectedLayout === 'verticalPresentation'
        ) {
          const mainPanel = document.getElementById('main-panel');

          if (!mainPanel) return;

          // Find the first div inside the main panel whose id starts with 'OT'
          const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
            (div) =>
              div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
          );
          resetStyles(otDiv, mainPanel);
          // If such a div exists, change its width
          if (otDiv) {
            if (selectedLayout === 'verticalPresentation') {
              if (otDivs.length > 1) {
                // Create or select a wrapper for the otDivs to manage their layout
                let otWrapper = document.getElementById('ot-wrapper');
                if (!otWrapper) {
                  otWrapper = document.createElement('div');
                  otWrapper.id = 'ot-wrapper';
                  mainPanel.appendChild(otWrapper);
                }

                // Set the styles for the wrapper to display otDivs in a column
                otWrapper.style.display = 'flex';
                otWrapper.style.flexDirection = 'column';
                otWrapper.style.width = '20%';
                otWrapper.style.height = '100%';
                otWrapper.style.marginRight = '5px'; // Space between the otWrapper and the screen share

                // Move each otDiv into the wrapper and set their dimensions
                otDivs.forEach((otDiv) => {
                  otWrapper.appendChild(otDiv);
                  otDiv.style.width = '100%'; // Full width within the wrapper
                  otDiv.style.height = '20%'; // Fixed height for each otDiv
                  otDiv.style.marginBottom = '5px'; // Add spacing between each otDiv
                });

                // Ensure the screenShareDiv takes up the rest of the width
                screenShareDiv.style.width = '100%';
                screenShareDiv.style.height = '100%';
                screenShareDiv.style.display = 'block';

                console.log(
                  'Applied vertical presentation layout for multiple otDivs with 15% size.'
                );
              } else {
                let otWrapper = document.getElementById('ot-wrapper');
                // Remove the otWrapper but keep otDivs inside the mainPanel
                if (otWrapper) {
                  while (otWrapper.firstChild) {
                    mainPanel.appendChild(otWrapper.firstChild);
                  }
                  otWrapper.remove();
                }
                otDiv.style.height = '20%';
                otDiv.style.width = '20%';
                screenShareDiv.style.width = '100%';
              }
            } else {
              otDiv.style.width = '30%';
              otDiv.style.height = '100%';
              screenShareDiv.style.width = '70%';
              screenShareDiv.style.height = '100%';
            }

            // Change the width to 25%
            console.log('Changed the width of the first OT div to 25%');
          } else {
            console.log('No div with id starting with OT found.');
          }
        } else if (selectedLayout === 'bestFit') {
          resetStyles(otDiv, mainPanel);
          if (
            (mainPanelDivCheck.otDivCount > 2 &&
              mainPanelDivCheck.otDivCount < 5 &&
              !mainPanelDivCheck.isHlsScreenSharePresent) ||
            (mainPanelDivCheck.otDivCount >= 2 &&
              mainPanelDivCheck.isHlsScreenSharePresent &&
              mainPanelDivCheck.otDivCount < 4)
          ) {
            mainPanel.style.flexWrap = 'wrap';
            otDivs.forEach((otDiv, index) => {
              otDiv.style.width = '50%';
              otDiv.style.height = '45%';
            });
            if (mainPanelDivCheck.isHlsScreenSharePresent) {
              screenShareDiv.style.width = '50%';
              screenShareDiv.style.height = '45%';
            }
          } else if (
            mainPanelDivCheck.otDivCount >= 3 ||
            (mainPanelDivCheck.otDivCount >= 3 &&
              mainPanelDivCheck.isHlsScreenSharePresent)
          ) {
            // Arrange the streams in two rows with 3 streams in each row
            mainPanel.style.display = 'flex';
            mainPanel.style.flexWrap = 'wrap';

            otDivs.forEach((otDiv, index) => {
              otDiv.style.width = '33.33%';
              otDiv.style.height = '50%';
            });
            if (mainPanelDivCheck.isHlsScreenSharePresent) {
              screenShareDiv.style.width = '33.33%';
              screenShareDiv.style.height = '50%';
            }
          } else {
            otDiv.style.height = '100%';
            otDiv.style.width = '100%';
            if (mainPanelDivCheck.isHlsScreenSharePresent) {
              screenShareDiv.style.width = '100%';
              screenShareDiv.style.height = '100%';
            }
            if (otDivs && otDivs.length > 1) {
              otDivs &&
                otDivs.forEach((otDiv) => {
                  // Reset all styles for each otDiv
                  otDiv.style.height = '100%';
                  otDiv.style.width = '100%';
                });
            }
          }
        } else if (selectedLayout === 'pip') {
          // For Picture-in-Picture (PiP) layout
          const screenShareDiv = document.getElementById('hls-screen-shares'); // Assuming this is the screen share div

          if (screenShareDiv && otDiv) {
            // Ensure the main panel uses relative positioning
            mainPanel.style.position = 'relative';

            // Position the screen share div to take full space
            screenShareDiv.style.width = '100%';
            screenShareDiv.style.height = '100%';

            // Position the camera div on the top right corner, PiP style
            otDiv.style.position = 'absolute';
            otDiv.style.top = '0px'; // Distance from the top
            otDiv.style.right = '10px'; // Distance from the right
            otDiv.style.width = '15%'; // PiP size
            otDiv.style.height = '15%'; // PiP size
            otDiv.style.zIndex = '10'; // Ensure it's on top of the screen share
            console.log('Applied Picture-in-Picture layout.');
          }
        }
      }
    }
  }
  function resetStyles(otDiv, mainPanel) {
    // Reset all styles for otDiv
    otDiv.style.position = '';
    otDiv.style.top = '';
    otDiv.style.right = '';
    // otDiv.style.width = '';
    // otDiv.style.height = '';
    otDiv.style.zIndex = '';

    // Reset screenShareDiv styles
    // screenShareDiv.style.width = '';
    // screenShareDiv.style.height = '';

    // Reset mainPanel position
    mainPanel.style.position = '';
  }
  const resetLayouts = () => {
    const mainPanel = document.getElementById('main-panel');
    const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
      (div) => div.id && div.id.startsWith('OT')
    );
    if (otDiv) {
      if (
        selectedLayout === 'verticalPresentation' ||
        selectedLayout === 'custom'
      ) {
        otDiv.style.height = '100%';
        otDiv.style.width = '100%';
      } else if (
        (selectedLayout === 'bestFit' ||
          sessionStorage.getItem('layoutSelected') === 'bestFit') &&
        mainPanelDivCheck.otDivCount === 1
      ) {
        otDiv.style.height = '100%';
        otDiv.style.width = '100%';
      } else if (selectedLayout === 'pip') {
        if (otDiv) {
          // Ensure the main panel uses relative positioning
          mainPanel.style.position = '';
          // Position the camera div on the top right corner, PiP style
          otDiv.style.position = '';
          otDiv.style.top = ''; // Distance from the top
          otDiv.style.right = ''; // Distance from the right
          otDiv.style.width = '100%'; // PiP size
          otDiv.style.height = '100%'; // PiP size
          otDiv.style.zIndex = ''; // Ensure it's on top of the screen share
        }
      }
    }
  };
  useEffect(() => {
    if (selectedLayout) {
      changeLayout(selectedLayout);
      sessionStorage.setItem('layoutSelected', selectedLayout);
      if (window.session) {
        window.session.signal(
          {
            type: 'layout-change',
            data: selectedLayout,
          },
          (error) => {
            if (error) {
              console.error(
                'Error sending layout change signal:',
                error.message
              );
            }
          }
        );
      }
    }
  }, [selectedLayout]);

  useEffect(() => {
    if (window.session) {
      window.session.on('signal:layout-change', (event) => {
        const newLayout = event.data;
        changeLayout(newLayout);
        setSelectedLayout(newLayout);
        sessionStorage.setItem('layoutSelected', newLayout);
      });
    }
    return () => {
      if (window.session) {
        window.session.off('signal:layout-change');
      }
    };
  }, [window.session]);

  useEffect(() => {
    if (window.session) {
      window.session.on('signal:move-screenshare', (event) => {
        const target = event.data;
        const screenshareDiv = document.getElementById('hls-screen-shares');
        const mainPanel = document.getElementById('main-panel');
        const leftPanel = document.querySelector('.left-panel');

        if (screenshareDiv && target === 'main-panel' && mainPanel) {
          mainPanel.appendChild(screenshareDiv);
          //   screenshareDiv.classList.add('highlight-border');
          if (mainPanelDivCheck.otDivCount == 0) {
            screenshareDiv.style.height = '90%';
          }
          sessionStorage.setItem('isScreenshareInLive', true);
          console.log('Screen share div moved to main-panel based on signal');
        } else if (screenshareDiv && target === 'left-panel' && leftPanel) {
          resetLayouts();
          sessionStorage.setItem('isScreenshareInLive', false);
          const screenShareDiv = document.getElementById('hls-screen-shares');
          if (screenShareDiv) {
            screenShareDiv.style.height = '100%';
            screenShareDiv.style.width = '100%';
          }
          // leftPanel.prepend(screenshareDiv);
          const backstageButtonDiv =
            document.getElementById('backstage-button');
          // Insert screenshareDiv right after backstageButtonDiv
          backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
          //   screenshareDiv.classList.remove('highlight-border');
          screenshareDiv.style.height = '25%';
          console.log(
            'Screen share div moved back to left-panel based on signal'
          );
        }
        changeLayout(sessionStorage.getItem('layoutSelected'));
      });
    }
    return () => {
      if (window.session) {
        window.session.off('signal:layout-change');
      }
    };
  }, [window.session]);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <main
          className={`${condition ? 'custom-row' : ''} hls-main`}
          style={{ width: '100%' }}
        >
          <div style={{ display: 'flex' }}>
            <div
              className='left-panel'
              style={{
                width: '25vw',
                height: '80vh',
                marginTop: '45px',
                overflowY: 'scroll',
              }}
            >
              <div
                id='backstage-button'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {' '}
                <div className='backstage-button'>BACKSTAGE</div>
              </div>

              <div
                ref={publisherRef}
                id='publishers'
                className='camera-box'
                style={{ height: '25%', width: '100%', marginTop: '10px' }}
              ></div>
              <div
                onClick={() => handleScreenshareClicked()}
                id='hls-screen-shares'
                style={{
                  height: '25%',
                  width: '100%',
                  marginTop: '20px',
                  order: `${selectedLayout === 'bestFit' ? '' : '1'}`,
                  display: `${isScreenSharing ? 'block' : 'none'}`,
                }}
              ></div>
              <div
                ref={subscriberRef}
                id='subscribers'
                className='camera-box'
                style={{ height: '25%', width: '100%', marginTop: '20px' }}
              ></div>
            </div>
            <div
              id='main-panel'
              className='main-panel'
              style={{
                width: '73%',
                height: '85vh',
                display: 'flex',
                border: '1px solid white',
                marginTop: '10px',
                justifyContent: 'space-between', // Ensure left-right alignment
                alignItems: 'flex-start', // Align items to the top
              }}
            >
              <div className='live-button-container'>
                <div className='live-button'>LIVE</div>
              </div>
              {!isLoading && !isLocalUserConnected && window.session && (
                <div className='reconnect-banner' style={{ zIndex: 1000 }}>
                  <p>You have lost connection. Please reconnect.</p>
                  <button onClick={handleReconnect} className='reconnect-btn'>
                    Reconnect
                  </button>
                </div>
              )}
            </div>
          </div>

          {!isLoading && (
            <div className='hls-toolbar'>
              <HlsToolBar
                isScreenSharing={isScreenSharing}
                startScreenSharing={startScreenSharing}
                stopScreenSharing={stopScreenSharing}
                hlsData={window.session && window.session}
                OT={window.OT}
                Publisher={publisher}
                session={window.session}
                stats={stats}
                setBroadcastType={setBroadcastType}
                setSelectedLayouts={setSelectedLayout}
                isCurrentHost={isCurrentHost}
                setOpen={setOpen}
                open={open}
                setShowNotificationChat={setShowNotificationChat}
                showNotificationChat={showNotificationChat}
              />
            </div>
          )}
        </main>
        <HlsSideMenu
          session={window.session}
          isOpen={open}
          setShowNotificationChat={setShowNotificationChat}
        ></HlsSideMenu>
      </div>
    </>
  );
};

export default ManualComponent;
